/*
 * @Author: changcheng 364000100@#qq.com
 * @Date: 2025-05-27 15:14:57
 * @LastEditors: changcheng 364000100@#qq.com
 * @LastEditTime: 2025-07-10 10:28:09
 * @FilePath: /mvw_project/project_login_frontend/src/page/component/login/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useEffect, useState } from "react";
import { Form, Input, Button, Modal } from "antd";
import { encode } from "js-base64";
import "./index.scss";
import { connect } from "react-redux";
const { Search } = Input;
/**公共登录组件
 * 参数
 * mobile:手机号  默认为空,可传
 * mobileDisabled  手机号是否禁止编辑
 * submit 登录回调
 */
function Login(props: any) {
  const [randomImgUrl, setRandomImgUrl] = useState("");
  const { mobile, mobileDisabled, submit } = props;
  const [passwordVisible, setPasswordVisible] = useState(false);
  /**表单提交事件 */
  const onFinish = (val: any) => {
    let data = { ...val };
    data.mobile = encode(data.mobile);
    data.password = encode(data.password);
    data.randomCode = encode(data.randomCode);
    submit(data);
  };
  /**获取图形验证码 */
  const getRandomCode = async () => {
    return await fetch(`/main/ran/random`)
      .then(
        (response) => response.blob(),
        (error) => console.log("An error occurred.", error)
      )
      .then((blob: any) => {
        const randomImgUrl = window.URL.createObjectURL(blob);
        setRandomImgUrl(randomImgUrl);
      });
  };
  useEffect(() => {
    /**初始获取图形验证码 */
    getRandomCode();
  }, []);
  return (
    <div>
      <Form
        className="loginForm"
        onFinish={onFinish}
        initialValues={{ mobile: mobile || "" }}
      >
        <Form.Item
          name="mobile"
          rules={[{ required: true, message: "请输入您的手机号码" }]}
        >
          <Input
            placeholder="请输入手机号"
            disabled={mobileDisabled || false}
          ></Input>
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: "请输入您的密码" }]}
        >
          <Input.Password
            visibilityToggle={{
              visible: passwordVisible,
              onVisibleChange: setPasswordVisible,
            }}
            placeholder="请输入密码"
            autocomplete="new-password"
          ></Input.Password>
        </Form.Item>
        <Form.Item
          name="randomCode"
          rules={[{ required: true, message: "请输入图形验证码" }]}
        >
          <Search
            className="searchInput"
            placeholder="请输入图形验证码"
            enterButton={
              <img src={randomImgUrl} alt="验证码" onClick={getRandomCode} />
            }
            style={{ padding: "0" }}
            size="large"
          />
        </Form.Item>
        <Form.Item style={{ marginTop: "20px" }}>
          <Button type="primary" htmlType="submit">
            登录
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}
const getInitData = (state: { initData: Array<any> }) => {
  return {
    initData: state.initData,
  };
};
export default connect(getInitData)(Login);
